export const environment = {
  state: 'DEVELOP',
  API_URL: 'https://api-emc.tma-swerp.com',
  FE_URL: 'https://emc-dashboard.tma-swerp.com',
  clientId: 'd1f3b20e-843e-4bab-976e-4a01e14b1ccf',
  authorityId: '2fffd254-96d3-44e0-880f-e2e08199a583'
};
